<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img :src="`/layout/images/logo-${isDarkTheme ? 'white' : 'dark'}.svg`" alt="zeres" />
            <span class="footer-app-name">ZERES</span>
        </div>
        <span class="footer-copyright">&#169; Zeres B.V. - 2026</span>
    </div>
</template>

<script setup>
import { useLayout } from '@/layout/composables/layout';

const { isDarkTheme } = useLayout();
</script>
